// extracted by mini-css-extract-plugin
export default {"section":"Sphere_section__jhdTe","btn":"Sphere_btn__cTXV9"};